import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { ISelectCommodityOptions } from "../../entities/select-commodity-options";

@Component
export default class SelectCommodityDialog extends Vue {


    @Prop()
    value: ISelectCommodityOptions;

    mounted() {
        // Todo: Check if keypress capture is required
    }

    getCommoditySearchUrl(): string {
        const searchUrl = `\\api\\1.0\\nodes\\commodities?modelId=${this.value.modelId}&search=`;
        return searchUrl;

    }

    getUnitsSearchUrl(): string {
        const searchUrl = `\\api\\1.0\\nodes\\units?modelId=${this.value.modelId}&commodity=${this.value.commodityToEdit.commodity}&search=`;
        return searchUrl;
    }



}


// WEBPACK FOOTER //
// ./ClientApp/components/select-commodity-dialog/select-commodity-dialog.ts